import moment, { Moment } from 'moment';
import { Usuario } from '@lib/Sistema/Usuarios';

export class Modelo {

    public constructor( Json?: any ) {
        if ( Json )
            this.Json = Json;
    }

    public Json: any;
    public Existe: boolean = false;

    public get CreatedAt(): Moment {
        return this.Json.created_at ? moment( this.Json.created_at ) : moment( '' );
    }
    public get UpdatedAt(): Moment {
        return this.Json.updated_at ? moment( this.Json.updated_at ) : moment( '' );
    }

    public CreatedUser: Usuario;
    public UpdatedUser: Usuario;

    public async cargarUsuarios() {
        if ( this.Json.created_user )
            this.CreatedUser = await Usuario.create( this.Json.created_user );
        if ( this.Json.updated_user )
            this.UpdatedUser = await Usuario.create( this.Json.updated_user );
    }

}